import { render, staticRenderFns } from "./PhoneNumberDisplay.vue?vue&type=template&id=31af21e4"
import script from "./PhoneNumberDisplay.vue?vue&type=script&lang=js"
export * from "./PhoneNumberDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports